if (!customElements.get('quick-add-modal')) {
  customElements.define(
      'quick-add-modal',
      class QuickAddModal extends ModalDialog {
          constructor() {
              super();
              this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
          }

          hide(preventFocus = false) {
              const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
              if (cartNotification) cartNotification.setActiveElement(this.openedBy);
              this.modalContent.innerHTML = '';

              if (preventFocus) this.openedBy = null;
              super.hide();
          }

          show(opener) {
              opener.setAttribute('aria-disabled', true);
              opener.classList.add('loading');
              opener.querySelector('.loading__spinner').classList.remove('hidden');

              fetch(opener.getAttribute('data-product-url'))
                  .then((response) => {
                      return response.text();
                  })
                  .then((responseText) => {
                      const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                      this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
                      this.productElement.classList.forEach((classApplied) => {
                          if (classApplied.startsWith('color-') || classApplied === 'gradient')
                              this.modalContent.classList.add(classApplied);
                      });
                      this.preventDuplicatedIDs();
                      this.removeDOMElements();
                      this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

                      if (window.ProductModel) window.ProductModel.loadShopifyXR();

                      this.removeGalleryListSemantic();
                      this.updateImageSizes();
                      this.preventVariantURLSwitching();
                      super.show(opener);
                  })
                  .finally(() => {
                      opener.removeAttribute('aria-disabled');
                      opener.classList.remove('loading');
                      opener.querySelector('.loading__spinner').classList.add('hidden');
                      const _this = this;
                      setTimeout(_this.initSlider(), 100);
                  });
          }

          initSlider() {
              const _this = this;
              //Product page option frames changer
              $('.option-framing label').on('click',function(){
                  $('.main-product-gallery div:not(.other) .card__media').css('background-image', "url(" +  $('.option-framing #' + $(this).attr('for')).data('url') + ")");
              });
              if ($('.option-framing input:checked').length > 0) {
                  $('.main-product-gallery div:not(.other) .card__media').css('background-image', "url(" +  $('.option-framing input:checked').data('url') + ")");
              }

              //Product page option frames size wall preview
              $('.option-print-size label').on('click',function(){
                  $('.main-product-gallery .slide-wall-preview').attr('data-frame-size',  $('.option-print-size #' + $(this).attr('for')).data('frame-size'));
              });
              if ($('.option-print-size input:checked').length > 0) {
                  $('.main-product-gallery .slide-wall-preview').attr('data-frame-size',  $('.option-print-size input:checked').data('frame-size'));
              }

              if ($('.main-product-gallery').length > 0) {
                  //Product page main slider
                setTimeout(function(){
                  $('.main-product-gallery').slick({
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      arrows: false,
                      fade: false,
                      asNavFor: '.main-thubnails',
                      responsive: [
                          {
                              breakpoint: 767,
                              settings: {
                                  slidesToShow: 1,
                                  dots: true
                              }
                          }
                      ]
                  });
                  //Product page main slider thumbnails
                  $('.main-thubnails').slick({
                      slidesToShow: 3,
                      slidesToScroll: 1,
                      asNavFor: '.main-product-gallery',
                      dots: false,
                      centerMode: false,
                      focusOnSelect: true
                  });
                  if (window.matchMedia("(max-width: 767px)").matches) {
                      $('.main-thubnails').slick('unslick');
                  }
                }, 50);
              }

              $('#anti-glare').change(function() {
                  $('.js-cb-framing-swatch-container label').removeClass('pseudo-checked-swatch');

                  if (this.checked) {
                      $('#anti-glare').attr('checked', "true");
                      $('#anti-glare').prop('checked', true);

                      let selectedFramingSwatch = $('input[type="radio"][name="Framing"]:checked');
                      if (selectedFramingSwatch.length === 1) {
                          let framingContainer = $(selectedFramingSwatch).parents('.js-cb-framing-swatch-container');

                          if (framingContainer.length === 1) {
                              let framingHandle = $(framingContainer).data('framing_swatch');

                              let antiGlareFramingContainer = $('.js-cb-framing-swatch-container[data-framing_swatch="' + framingHandle + ' Anti-Glare' + '"]');
                              if (antiGlareFramingContainer.length === 1) {
                                  $(selectedFramingSwatch).removeAttr('checked');
                                  $(selectedFramingSwatch).prop('checked', false);

                                  $(antiGlareFramingContainer).find('label').click();
                                  $(framingContainer).find('label').addClass('pseudo-checked-swatch');
                              }
                          }
                      }
                  } else {
                      document.getElementById(`anti-glare`).removeAttribute('checked');
                      $('#anti-glare').removeAttr('checked');
                      $('#anti-glare').prop('checked', false);

                      let selectedFramingSwatch = $('input[type="radio"][name="Framing"]:checked');
                      if (selectedFramingSwatch.length === 1) {
                          let framingContainer = $(selectedFramingSwatch).parents('.js-cb-framing-swatch-container');

                          if (framingContainer.length === 1) {
                              let framingHandle = $(framingContainer).data('framing_swatch');

                              let antiGlareFramingContainer = $('.js-cb-framing-swatch-container[data-framing_swatch="' + framingHandle.replace(' Anti-Glare', '') + '"]');

                              if (antiGlareFramingContainer.length === 1) {
                                  $(selectedFramingSwatch).removeAttr('checked');
                                  $(selectedFramingSwatch).prop('checked', false);

                                  $(antiGlareFramingContainer).find('label').click();
                              }
                          }
                      }
                  }
              });

              //Product page option frames changer
              $('.option-framing label').on('click',function(){
                  if ($('.main-product-gallery div:not(.other) .card__media').length > 1 ){
                      $('.main-product-gallery div:not(.other) .card__media').css('background-image', "url(" +  $('.option-framing #' + $(this).attr('for')).data('url-ns') + ")");
                      $('.main-product-gallery div:not(.other) .card__media:last-child').css('background-image', "url(" +  $('.option-framing #' + $(this).attr('for')).data('url') + ")");
                  } else {
                      $('.main-product-gallery div:not(.other) .card__media').css('background-image', "url(" +  $('.option-framing #' + $(this).attr('for')).data('url') + ")");
                  }
              });

              //Product page option frames changer default without click
              if ($('.option-framing input:checked').length > 0) {

                  if ($('.main-product-gallery div:not(.other) .card__media').length > 1 ){
                      $('.main-product-gallery div:not(.other) .card__media').css('background-image', "url(" +  $('.option-framing input:checked').data('url-ns') + ")");
                      $('.main-product-gallery div:not(.other) .card__media:last-child').css('background-image', "url(" +  $('.option-framing input:checked').data('url') + ")");
                  } else {
                      $('.main-product-gallery div:not(.other) .card__media').css('background-image', "url(" +  $('.option-framing input:checked').data('url') + ")");
                  }

              }

              //Product page option frames size wall preview
              $('.option-print-size label').on('click',function(){
                  $('.main-product-gallery .slide-wall-preview').attr('data-frame-size',  $('.option-print-size #' + $(this).attr('for')).data('frame-size'));
              });
              if ($('.option-print-size input:checked').length > 0) {
                  $('.main-product-gallery .slide-wall-preview').attr('data-frame-size',  $('.option-print-size input:checked').data('frame-size'));
              }

              /*Product Hint*/
              $('.hint-description').appendTo('body');
              $('.hint-block .hint').on({
                  mouseenter: function () {
                      var dataHint = $(this).data('hint');
                      var mouseX = 0, mouseY = 0;
                      var xp = 0, yp = 0;

                      $(this).mousemove(function(e){
                          mouseX = e.pageX ;
                          mouseY = e.pageY ;

                          $('.hint-description').each(function(){
                              if ($(this).data('hint-desc') == dataHint) {

                                  $(this).addClass('hint-hovered');
                                  if ($(this).hasClass('hint-hovered')) {


                                      $(this).css({
                                          top: mouseY + 20 +'px',
                                          left: mouseX - $(this).outerWidth() + 30 + 'px'
                                      })
                                      var pos = $(this).position(),
                                          posX = pos.left;
                                      if (posX < 0 || posX == 15 ) {
                                          $(this).css('left', '15px');
                                      }
                                  } else {
                                      $(this).removeClass('hint-hovered');
                                  }
                              }
                          })
                      });


                  },
                  mouseleave: function () {
                      $('.hint-description').removeClass('hint-hovered');
                  }
              });

              // Update button
              const updateBtn = $('.cart-update-product-btn');

              $(updateBtn).click(function (e) {
                  e.preventDefault();
                  let variantId = $(this).data('current_var_id');
                  let itemProps = '';
                  let lineEl = $(this).parents('.js-main-cart-edit');
                  let lineNr = null;

                  if (lineEl.length > 0) {
                      lineNr = $(lineEl).data('line_item');
                      itemProps = $(lineEl).data('item_props');

                      $(lineEl).parents('.quick-add-modal__content').find('.quick-add-modal__toggle')[0].click();
                  }
                  _this.updateVariantId(lineNr, variantId, itemProps);
              });
          }

          updateVariantId(lineNr, variantId, itemProps) {
              const cartItems = document.querySelector('cart-items');

              cartItems.updateVariantId(lineNr, variantId, itemProps);
          }

          setInnerHTML(element, html) {
              element.innerHTML = html;

              // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
              element.querySelectorAll('script').forEach((oldScriptTag) => {
                  const newScriptTag = document.createElement('script');
                  Array.from(oldScriptTag.attributes).forEach((attribute) => {
                      newScriptTag.setAttribute(attribute.name, attribute.value);
                  });
                  newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
                  oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
              });
          }

          preventVariantURLSwitching() {
              const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
              if (!variantPicker) return;

              variantPicker.setAttribute('data-update-url', 'false');
          }

          removeDOMElements() {
              const pickupAvailability = this.productElement.querySelector('pickup-availability');
              if (pickupAvailability) pickupAvailability.remove();

              const productModal = this.productElement.querySelector('product-modal');
              if (productModal) productModal.remove();

              //const productButton = this.productElement.querySelector('.product-form__buttons');
              //if (productButton) productButton.remove();

              const modalDialog = this.productElement.querySelectorAll('modal-dialog');
              if (modalDialog) modalDialog.forEach((modal) => modal.remove());
          }

          preventDuplicatedIDs() {
              const sectionId = this.productElement.dataset.section;
              this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
              this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
                  element.dataset.originalSection = sectionId;
              });
          }

          removeGalleryListSemantic() {
              const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
              if (!galleryList) return;

              galleryList.setAttribute('role', 'presentation');
              galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
          }

          updateImageSizes() {
              const product = this.modalContent.querySelector('.product');
              const desktopColumns = product.classList.contains('product--columns');
              if (!desktopColumns) return;

              const mediaImages = product.querySelectorAll('.product__media img');
              if (!mediaImages.length) return;

              let mediaImageSizes =
                  '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

              if (product.classList.contains('product--medium')) {
                  mediaImageSizes = mediaImageSizes.replace('715px', '605px');
              } else if (product.classList.contains('product--small')) {
                  mediaImageSizes = mediaImageSizes.replace('715px', '495px');
              }

              mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
          }
      }
  );
}
